import React, {useState} from "react";
import { Table } from "antd";
import { useSelector } from "react-redux";
import _ from "lodash";


const fmt = (num) =>
  Number(num || 0).toLocaleString(undefined, {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  });

const IndirectIncomeBalanceTable = ({ printMode = false }) => {
  const { list, loading } = useSelector((state) => state.indirectIncomeBalance);
  const [pagination, setPagination] = useState({
    current: 1,
    pageSize: 10,
  });

  const handleTableChange = (pagination) => {
    setPagination(pagination);
  };

  const openingTotal = _.sumBy(list, (r) => Number(r.opening_balance) || 0);
  const debitTotal = _.sumBy(list, (r) => Number(r.debit_amount) || 0);
  const creditTotal = _.sumBy(list, (r) => Number(r.credit_amount) || 0);
  const balanceTotal = _.sumBy(list, (r) => Number(r.balance) || 0);

  const columns = [
    { title: "No.", render: (_, __, index) => index + 1, width: 60 },
    { title: "Account Name", dataIndex: "acc_name" },
    {
      title: "Opening Balance",
      dataIndex: "opening_balance",
      align: "right",
      render: (val) => fmt(val),
    },
    {
      title: "Debit Amount",
      dataIndex: "debit_amount",
      align: "right",
      render: (val) => fmt(val),
    },
    {
      title: "Credit Amount",
      dataIndex: "credit_amount",
      align: "right",
      render: (val) => fmt(val),
    },
    {
      title: "Balance",
      dataIndex: "balance",
      align: "right",
      render: (val) => fmt(val),
    },
  ];

  if (printMode) {
  return (
    <table className="iib-print-table">
      <colgroup>
        <col style={{ width: "6%" }} />
        <col style={{ width: "34%" }} />
        <col style={{ width: "15%" }} />
        <col style={{ width: "15%" }} />
        <col style={{ width: "15%" }} />
        <col style={{ width: "15%" }} />
      </colgroup>

      <tbody>
        <tr className="iib-print-heading">
          <td>No.</td>
          <td>Account Name</td>
          <td style={{ textAlign: "right" }}>Opening Balance</td>
          <td style={{ textAlign: "right" }}>Debit Amount</td>
          <td style={{ textAlign: "right" }}>Credit Amount</td>
          <td style={{ textAlign: "right" }}>Balance</td>
        </tr>

        {list.map((row, index) => (
          <tr key={row.acc_id || index}>
            <td>{index + 1}</td>

            <td>{row.acc_name}</td>

            <td style={{ textAlign: "right" }}>
              {fmt(row.opening_balance)}
            </td>

            <td style={{ textAlign: "right" }}>
              {fmt(row.debit_amount)}
            </td>

            <td style={{ textAlign: "right" }}>
              {fmt(row.credit_amount)}
            </td>

            <td style={{ textAlign: "right" }}>
              {fmt(row.balance)}
            </td>
          </tr>
        ))}

        <tr className="iib-print-total">
          <td colSpan={2} style={{ textAlign: "right" }}>
            Grand Total :
          </td>

          <td style={{ textAlign: "right" }}>
            {fmt(openingTotal)}
          </td>

          <td style={{ textAlign: "right" }}>
            {fmt(debitTotal)}
          </td>

          <td style={{ textAlign: "right" }}>
            {fmt(creditTotal)}
          </td>

          <td style={{ textAlign: "right" }}>
            {fmt(balanceTotal)}
          </td>
        </tr>
      </tbody>
    </table>
  );
}

  return (
    <Table
      rowKey={(record, idx) => record.acc_id || idx}
      columns={columns}
      dataSource={list}
      loading={loading}
      pagination={{
        ...pagination,
        showSizeChanger: true,
        pageSizeOptions: ["10", "20", "50"],
      }}
      onChange={handleTableChange}
      bordered
      size={printMode ? "small" : "middle"}
      summary={() => (
        <Table.Summary.Row>
          <Table.Summary.Cell index={0} colSpan={2} align="right">
            <strong>Grand Total :</strong>
          </Table.Summary.Cell>
          <Table.Summary.Cell index={2} align="right">
            <strong>{fmt(openingTotal)}</strong>
          </Table.Summary.Cell>
          <Table.Summary.Cell index={3} align="right">
            <strong>{fmt(debitTotal)}</strong>
          </Table.Summary.Cell>
          <Table.Summary.Cell index={4} align="right">
            <strong>{fmt(creditTotal)}</strong>
          </Table.Summary.Cell>
          <Table.Summary.Cell index={5} align="right">
            <strong>{fmt(balanceTotal)}</strong>
          </Table.Summary.Cell>
        </Table.Summary.Row>
      )}
    />
  );
};

export default IndirectIncomeBalanceTable;
